import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'label', 'extra']
  static values = {
    type: String,
    allLabel: String
  }

  connect() {
    this.update()
  }

  update() {
    switch (this.typeValue) {
      case 'multi':   return this.updateMulti()
      case 'boolean': return this.updateBoolean()
      case 'range':   return this.updateRange()
    }
  }

  updateMulti() {
    const checked = Array.from(this.element.querySelectorAll('input[type="checkbox"]:checked'))
    const labels = checked.map(c => (c.dataset.chipLabel || '').trim()).filter(Boolean)
    if (labels.length === 0) {
      this._render(this.allLabelValue, '', false)
    } else {
      const extra = labels.length > 1 ? `+${labels.length - 1}` : ''
      this._render(labels[0], extra, true)
    }
  }

  updateBoolean() {
    const radio = this.element.querySelector('input[type="radio"]:checked')
    if (!radio || !radio.value) {
      this._render(this.allLabelValue, '', false)
    } else {
      this._render(radio.dataset.chipLabel || '', '', true)
    }
  }

  updateRange() {
    const inputs = this.element.querySelectorAll('input[data-range-input]')
    const min = inputs[0]?.value?.trim() || ''
    const max = inputs[1]?.value?.trim() || ''
    let label = this.allLabelValue
    let active = false
    if (min && max) { label = `${min} – ${max}`; active = true }
    else if (min)   { label = `≥ ${min}`;        active = true }
    else if (max)   { label = `≤ ${max}`;        active = true }
    this._render(label, '', active)
  }

  _render(main, extra, active) {
    if (this.hasLabelTarget) this.labelTarget.textContent = main
    if (this.hasExtraTarget) {
      this.extraTarget.textContent = extra
      this.extraTarget.classList.toggle('hidden', !extra)
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.toggle('is-active', active)
    }
  }
}
